// extracted by mini-css-extract-plugin
module.exports = {"TourBox":"SidePanel_TourBox___hlfS","EventsHeader":"SidePanel_EventsHeader__rtufg"};